/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type evidenceMain_tagFilter = {
    readonly tags: ReadonlyArray<{
        readonly id: string;
        readonly tagId: number;
        readonly text: string;
    }>;
    readonly " $refType": "evidenceMain_tagFilter";
};
export type evidenceMain_tagFilter$data = evidenceMain_tagFilter;
export type evidenceMain_tagFilter$key = {
    readonly " $data"?: evidenceMain_tagFilter$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"evidenceMain_tagFilter">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "evidenceMain_tagFilter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FolderTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tagId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Folder",
  "abstractKey": "__isFolder"
};
(node as any).hash = 'a7db85523d3e9ac8c1916514936b9ebb';
export default node;
